import Vue from 'vue'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import {
  faTrashAlt,
  faImage,
  faEnvelope
} from '@fortawesome/fontawesome-free-regular'
import {
  faUser,
  faUserPlus,
  faSignOutAlt,
  faAngleLeft,
  faAngleDoubleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faAngleUp,
  faPlus,
  faTimes,
  faEdit,
  faBan,
  faCheck,
  faEllipsisH
} from '@fortawesome/fontawesome-free-solid'

fontawesome.library.add(faUser)
fontawesome.library.add(faUserPlus)
fontawesome.library.add(faSignOutAlt)

fontawesome.library.add(faAngleLeft)
fontawesome.library.add(faAngleDoubleLeft)
fontawesome.library.add(faAngleRight)
fontawesome.library.add(faAngleDoubleRight)
fontawesome.library.add(faAngleUp)

fontawesome.library.add(faPlus)
fontawesome.library.add(faTimes)
fontawesome.library.add(faEdit)
fontawesome.library.add(faCheck)
fontawesome.library.add(faBan)
fontawesome.library.add(faTrashAlt)
fontawesome.library.add(faImage)
fontawesome.library.add(faEllipsisH)
fontawesome.library.add(faEnvelope)

Vue.component('font-awesome-icon', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./src/utils/fontawesome.js